import React from "react";
import { useState } from "react";

import { Form, Card, Dropdown, Button,Row, Col } from "react-bootstrap";
import { FaDownload, FaRedo, FaPaperPlane, FaArrowDown } from "react-icons/fa";
import ExpertDescriptionEdit from "../components/ExpertDescriptionEdit";

import '../css/main.css';

const ExpertAudioRedescribe = ({
  videoname, setVideoname,
  videoDescription, setVideoDescription,
  model, setModel,
  language, setLanguage,
  descriptionType, setDescriptionType,
  voice, setVoice,
  mediaFormats, mediaFormatError,
  toggleFormat,
  handleRedescribe,
  isRedescribing,
  progress,
  handleExport,
  redescribeVideodetails,
  video,
  videoRef,
}) => {
const [activeTab, setActiveTab] = useState("original");
console.log("redescribeVideodetails",redescribeVideodetails);


  return (

   <>
      <Card className="shadow-sm border-0 p-3 redescribe-div" 
       role="region" aria-labelledby="audiodescription_header">
        {/* <Card.Title className="text-center mb-2" id="audiodescription_header">Audio Description Generator</Card.Title> */}

        <Form aria-describedby="form-help">
 <p id="form-help" className="visually-hidden">
        Use this form to generate audio description for the selected video.
      </p>

{/* <Row className="mb-2">
  <Col md={6}>

    <Form.Group>
            <Form.Label htmlFor="narratorSelect" className="small-label">Narrator</Form.Label>
            <Form.Select size="sm" className="small-select"
             id="narratorSelect"
  value={model} aria-label="Select Narrator Model"
  onChange={(e) => setModel(e.target.value)}
>
  {redescribeVideodetails?.data?.form_data?.model_choices?.[0]?.map((item, idx) => (
    <option key={idx} value={item.key}>
      {item.label}
    </option>
  ))}
  </Form.Select>
    </Form.Group>
  </Col>
 <Col md={6}>
    <Form.Group>
            <Form.Label htmlFor="languageSelect" className="small-label">Language</Form.Label>
            <Form.Select  size="sm" className="small-select" id="languageSelect" value={language} aria-label="Select Language"
            onChange={(e) => setLanguage(e.target.value)}>
                {redescribeVideodetails?.data?.form_data?.languages?.[0]?.map((lang, idx) => (
      <option key={idx} value={lang[0]}>
        {lang[1]}
      </option>
    ))}
           </Form.Select>
    </Form.Group>
  </Col>
</Row>
        <Row className="mb-2">
  <Col md={6}>
    <Form.Group>
            <Form.Label htmlFor="descriptionTypeSelect" className="small-label">Description Type</Form.Label>
            <Form.Select size="sm" className="small-select" id="descriptionTypeSelect" value={descriptionType} aria-label="Select Description Type"
            onChange={(e) => setDescriptionType(e.target.value)}>
               {redescribeVideodetails?.data?.form_data?.description_types?.[0]?.map((item, idx) => (
      <option key={idx} value={item}>
        {item}
      </option>
    ))}
               </Form.Select>
    </Form.Group>
 </Col>
           <Col md={6}>
    <Form.Group>
            <Form.Label htmlFor="voiceSelect" className="small-label">Voice</Form.Label>
            <Form.Select value={voice} 
            id="voiceSelect" size="sm" className="small-select"
             aria-label="Select Voice Gender"
            onChange={(e) => setVoice(e.target.value)}>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              </Form.Select>
    </Form.Group>
  </Col>
</Row>


<div className="center-wrapper">
            <Button size="sm"

              onClick={handleRedescribe}
              className="center-btn flex-fill redescribe-btn me-2"
              disabled={isRedescribing}
               aria-disabled={isRedescribing}
        aria-describedby="progressStatus"
            >
              {isRedescribing ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing... {progress}%
                </>
              ) : (
                <>
                  <FaRedo className="me-1" aria-hidden="true" /> Redescribe
                </>
              )}
            </Button>
          </div> */}

<Row className="align-items-end g-2">

  {/* Narrator */}
  <Col md={2}>
    <Form.Group>
      <Form.Label className="small-label">Narrator</Form.Label>
      <Form.Select
        size="sm"
        className="small-select"
        value={model}
        onChange={(e) => setModel(e.target.value)}
      >
        {redescribeVideodetails?.data?.form_data?.model_choices?.[0]?.map(
          (item, idx) => (
            <option key={idx} value={item.key}>
              {item.label}
            </option>
          )
        )}
      </Form.Select>
    </Form.Group>
  </Col>

  {/* Language */}
  <Col md={2}>
    <Form.Group>
      <Form.Label className="small-label">Language</Form.Label>
      <Form.Select
        size="sm"
        className="small-select"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
      >
        {redescribeVideodetails?.data?.form_data?.languages?.[0]?.map(
          (lang, idx) => (
            <option key={idx} value={lang[0]}>
              {lang[1]}
            </option>
          )
        )}
      </Form.Select>
    </Form.Group>
  </Col>

  {/* Description Type */}
  <Col md={2}>
    <Form.Group>
      <Form.Label className="small-label">Description Type</Form.Label>
      <Form.Select
        size="sm"
        className="small-select"
        value={descriptionType}
        onChange={(e) => setDescriptionType(e.target.value)}
      >
        {redescribeVideodetails?.data?.form_data?.description_types?.[0]?.map(
          (item, idx) => (
            <option key={idx} value={item}>
              {item}
            </option>
          )
        )}
      </Form.Select>
    </Form.Group>
  </Col>

  {/* Voice */}
  <Col md={2}>
    <Form.Group>
      <Form.Label className="small-label">Voice</Form.Label>
      <Form.Select
        size="sm"
        className="small-select"
        value={voice}
        onChange={(e) => setVoice(e.target.value)}
      >
        <option value="Male">Male</option>
        <option value="Female">Female</option>
      </Form.Select>
    </Form.Group>
  </Col>

  {/* Button */}
  <Col md={2}>
    <Button
      size="sm"
      className="w-100 redescribe-btn"
      onClick={handleRedescribe}
      disabled={isRedescribing}
    >
      {isRedescribing ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" />
          Processing... {progress}%
        </>
      ) : (
        <>
          <FaRedo className="me-1" /> Regenerate Description
        </>
      )}
    </Button>
  </Col>

</Row>

             {/* Screen reader progress */}
      <div id="progressStatus" className="visually-hidden">
        {isRedescribing
          ? `Processing in progress. ${progress} percent completed.`
          : "Ready to generate audio description."}
      </div>
        </Form>
      </Card>

     
  {/* <ExpertDescriptionEdit
      video={video}
      videoRef={videoRef}
    /> */}



      
    </>
        
  );
};

export default ExpertAudioRedescribe;
